<mat-card>
    <mat-form-field appearance="fill">
        <mat-label>Defaut GST</mat-label>
        <input matInput [(ngModel)]="defaultGST" (change)="setComission()">
    </mat-form-field>
    <mat-button-toggle-group [(ngModel)]="defaultTaxType" aria-label="Font Style" (change)="setGSTType()">
        <mat-button-toggle value="CGST + SGST">C + S</mat-button-toggle>
        <mat-button-toggle value="IGST">I</mat-button-toggle>
        <mat-button-toggle value="CGST + UGST/UTGST">C + U/UT</mat-button-toggle>
    </mat-button-toggle-group>
</mat-card>

<table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">


    <!-- Name Column -->
    <ng-container matColumnDef="Ml">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Menu Heading </th>
        <td mat-cell *matCellDef="let element"> {{element.Ml}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let element"> {{element.Name}} </td>
    </ng-container>


    <!-- Symbol Column -->
    <ng-container matColumnDef="TaxType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
        <td mat-cell *matCellDef="let element">
            <mat-button-toggle-group [(ngModel)]="element.TaxType" aria-label="Font Style">
                <mat-button-toggle value="CGST + SGST">C + S</mat-button-toggle>
                <mat-button-toggle value="IGST">I</mat-button-toggle>
                <mat-button-toggle value="CGST + UGST/UTGST">C + U/UT</mat-button-toggle>
            </mat-button-toggle-group>
        </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="GST">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> GST </th>
        <td mat-cell *matCellDef="let element">
            <mat-form-field style="width: 50px;" appearance="outline">
                <input [(ngModel)]="element.GST" (click)="$event.target.select()" (change)="element.changed=true"
                    matInput>
            </mat-form-field>
        </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
    <tr mat-row *matRowDef="let row; columns: columnNames;"></tr>
</table>


<mat-card>
    <button mat-raised-button color="primary" (click)="submit()">Submit</button>
</mat-card>

<!-- Copyright 2021 Google LLC. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->